angular.module('gym.privacy_policies', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.privacy_policies', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.privacy_policies.list', {
    url: '/privacy_policies',
    controller: 'PrivacyPoliciesCtrl',
    template: require('templates/gyms/privacy_policies/index.html.slim'),
    resolve: {
      policiesMeta: ["PrivacyPolicies", function(PrivacyPolicies) {
        return PrivacyPolicies.get('meta');
      }]
    }
  }).state('gym.privacy_policies.new', {
    url: '/privacy_policies/new',
    controller: 'EditPrivacyPolicyCtrl',
    template: require('templates/gyms/privacy_policies/edit.html.slim'),
    resolve: {
      policy: function() {
        return {
          enabled: false
        };
      },
      title: function() {
        return 'New Consent Clause';
      },
      policiesMeta: ["PrivacyPolicies", function(PrivacyPolicies) {
        return PrivacyPolicies.get('meta');
      }]
    }
  }).state('gym.privacy_policies.edit', {
    url: '/privacy_policies/:policyId/edit',
    controller: 'EditPrivacyPolicyCtrl',
    template: require('templates/gyms/privacy_policies/edit.html.slim'),
    resolve: {
      policy: ["$stateParams", "PrivacyPolicies", function($stateParams, PrivacyPolicies) {
        return PrivacyPolicies.get($stateParams.policyId);
      }],
      title: function() {
        return 'Edit Consent Clause';
      },
      policiesMeta: ["PrivacyPolicies", function(PrivacyPolicies) {
        return PrivacyPolicies.get('meta');
      }]
    }
  }).state('gym.privacy_policies.user_policy_responses', {
    url: '/user_policy_responses',
    controller: 'UserPolicyResponsesCtrl',
    template: require('templates/gyms/privacy_policies/user_policy_responses.html.slim')
  });
}]);
